import React, { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

import SysStroreFilterForm from './../../sysStore/component/SysStroreFilterForm';
import PropConfigFilter from './../../propConfig/component/PropConfigFilter';
import FileFilterForm from './../../intFile/component/FileFilterForm';
import SysApiLogFilterForm from "./../..//sysApilog/component/SysApiLogFilterForm";
import PosJournalFilter from './../../posJournal/component/PosJournalFilter';
import StoreItemFilterForm from "./../../inventory/component/StoreItemFilterForm";
import SysEventsFilterForm from "./../../sysEvents/cimponent/SysEventsFilterForm";

import { isPermissionCodeValid, tableNameOptions } from '../../../utils/mics';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import IntOutBoundFileFilterForm from '../../intOutboundFile/component/intOutBoundFileFilterForm';
import FileUploadFilterForm from '../../fileUpload/component/FileUploadFilterForm';
import SysAppLoggerFilterForm from '../../sysAppLogger/component/SysAppLoggerFilterForm';
import SysErrorCodeFilterForm from '../../sysErrorCode/component/SysErrorCodeFilterForm';

const ExportLogs  = () => {
    
    const dispatch = useDispatch();

    const { type } = useParams(); 

    const pageId = type === 'table-log' ? "M04-1" : "M04-6"

    const readAccess = isPermissionCodeValid(`${pageId}-R`);
    // const writeAccess = isPermissionCodeValid(`${pageId}-W`);
    // const deleteAccess = isPermissionCodeValid(`${pageId}-D`);

    const {filters} = useSelector((state) => state.devOpsTool);

    const defaultParams = useMemo(() => ({
        ...filters,
        pageno: 1,
        pagesize: 10,
        sort: 'createdOn',
        sortOrder: -1,
    }), [filters]);

    const [tableName, setTableName] = useState(null);

    const [fileIds, setFileIds] = useState('');

    const handleSearch = useCallback(
        (params) => {
            const searchParams = {
                tableName,
                ...params,
                pagesize: params.pagesize || defaultParams.pagesize,
                pageno: params.pageno || defaultParams.pageno,
                sort: params.sort || defaultParams.sort,
                sortOrder: params.sortOrder || defaultParams.sortOrder,
            };
            dispatch(appActions.EXPORTLOGS_GET_TABLE_LOG_REQUEST(searchParams));
        },
        [dispatch, defaultParams, tableName]
    );

    const handleReset = () => {
        setTableName(null)
    };

    const handleIdsClear = () =>{
        setFileIds('')
    }
    

    const handleFileLogSearch = useCallback(
        (params) => {
            dispatch(appActions.EXPORTLOGS_GET_FILE_LOG_REQUEST(fileIds));
        },
        [dispatch, fileIds] 
    );

    const handleFormValuesChange = (values) => {
        //setFormValues(values);
    };

    const renderFilterForm = (tableName) => {
        return (
            <>
                {tableName === 'sys_store' && (
                    <SysStroreFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'sys_prop_config' && (
                    <PropConfigFilter
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'sys_apilog' && (
                    <SysApiLogFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'sys_applogger' && (
                    <SysAppLoggerFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'sys_errorcodes' && (
                    <SysErrorCodeFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'integration_file' && (
                    <FileFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'integration_file_uploadq' && (
                    <FileUploadFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'integration_file_pjo' && (
                    <PosJournalFilter
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'integration_file_itt' && (
                    <StoreItemFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
                {tableName === 'integration_file_cmd' && (
                    <SysEventsFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}

                {tableName === 'integration_file_outbound' && (
                    <IntOutBoundFileFilterForm
                        handleSearch={handleSearch}
                        handleReset={handleReset}
                        onFormValuesChange={handleFormValuesChange}
                    />
                )}
            </>
        );
    };

    const handleChange = (e) => {
        setTableName(e?.value);
    };

    const handleFileIdChange = (e) => {
        setFileIds(e?.target?.value); // Get the value from the event object
    };

    const renderHeader = () => (
        <div className="col-6">
            <h1 className="page-header flex"> Export {type === 'table-log' ? 'Table' : 'File'} Log </h1>
        </div>
    );

    const renderList = () => (
        <>
            <div className="grid px-4 align-items-center my-2">{renderHeader()}</div>
            <div className="bg-white mx-4 pv-20 ph-20 br-6 shadow-white">

                {type === 'table-log' && (
                    <>
                        <div className="grid p-2">
                            <div className="p-fluid formgrid grid w-full">
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="title">Table Name</label>
                                    <Dropdown showClear 
                                        placeholder="Select Table Name"
                                        value={tableName}
                                        onChange={handleChange}
                                        options={tableNameOptions}
                                        id="tableName"
                                        name="tableName"
                                        optionLabel="name"
                                        optionValue="code"
                                    />
                                </div>
                            </div>
                        </div>
                        {tableName && renderFilterForm(tableName)}
                    </>
                )}

                {type === 'file-log' && (
                    <>
                        <div className="grid p-2">
                            <div className="p-fluid formgrid grid w-full">
                                <div className="field col-12 md:col-6">
                                    <label htmlFor="title">File IDs</label>
                                    <InputText
                                        id="fileIds"
                                        name="fileIds"
                                        type="text"
                                        placeholder='Enter multiple file IDs, separated by commas (e.g., 123, 456, 789)'
                                        value={fileIds}
                                        onChange={handleFileIdChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="grid px-2 py-4 flex-row-reverse gap-10">
                            {readAccess && <>
                                <Button type="button" label="Export Logs" onClick={handleFileLogSearch} className="p-button-success mr-2" />
                                <Button type="button" label="Clear" severity="secondary" onClick={handleIdsClear} />
                            </>}
                        </div>
                    </>
                )}                 
                
            </div>
        </>
    );

    return <div className="form_height">{renderList()}</div>;
};

export default ExportLogs;
